import React from "react";
import SectionWrapper from "../../components/SectionWrapper";
import Marquee from "react-fast-marquee";
import { BRANDS_LIST } from "../../utils/helpers";
import Img from "../../components/Img";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

const BrandList = () => {
  const nav = useNavigate();
  return (
    <SectionWrapper heading={"Brands"}>
      <div className="w-full h-full">
        <Marquee autoFill>
          {BRANDS_LIST.filter((_, i) => i <= BRANDS_LIST.length / 2).map(
            ({ logo, bg, _id }, idx) => (
              <div
                onClick={() =>
                  nav(`material-filter?brand=${encodeURIComponent(_id)}`)
                }
                className={classNames(
                  bg ? `${bg} p-1` : "",
                  "mx-4 cursor-pointer",
                )}
              >
                <Img
                  src={logo}
                  className={"max-h-32 max-w-32 w-32  object-contain "}
                />
              </div>
            ),
          )}
        </Marquee>
      </div>
      <div className="w-full h-full">
        <Marquee autoFill direction="right">
          {BRANDS_LIST.filter((_, i) => i > BRANDS_LIST.length / 2).map(
            ({ logo, bg, _id }, idx) => (
              <div
                onClick={() =>
                  nav(`material-filter?brand=${encodeURIComponent(_id)}`)
                }
                className={classNames(
                  bg ? `${bg} p-1` : "",
                  "mx-4 cursor-pointer",
                )}
              >
                <Img
                  src={logo}
                  className={"max-h-32 max-w-32 w-32  object-contain "}
                />
              </div>
            ),
          )}
        </Marquee>
      </div>
    </SectionWrapper>
  );
};

export default BrandList;
